import { GetAppOutlined } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useSearchQueryContext } from 'components/search/search.hooks';
import { useTranslation } from 'react-i18next';

const ExportButton = ({
  exportReportFunction,
  isAdditionalLoading,
}: {
  exportReportFunction: () => Promise<void>;
  isAdditionalLoading: boolean;
}) => {
  const { t } = useTranslation();
  const query = useSearchQueryContext();

  return (
    <LoadingButton
      onClick={exportReportFunction}
      startIcon={<GetAppOutlined />}
      data-testid="SMSReports.Button.Export"
      sx={{ whiteSpace: 'nowrap' }}
      variant="text"
      disabled={
        query?.data?.paging?.total === 0 ||
        query?.searchResults?.length === 0 ||
        query?.queryState?.isFetching
      }
      loading={isAdditionalLoading}
    >
      {t('SearchDataGrid.ExportButton.label')}
    </LoadingButton>
  );
};

export default ExportButton;
